var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedditrSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 186.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#ff4404;}.cls-6{fill:none;stroke:#fff;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 305.71,
    y1: -176.89,
    x2: 443.43,
    y2: -241.11,
    gradientTransform: "translate(-308.5 344.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#55abed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5da6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4404"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 82.37,
    y1: 88.43,
    x2: 163.57,
    y2: 78.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55abed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#60a4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8a8ba5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ad7574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#cb644c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e2562c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f24c16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fc4609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff4404"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 374.93,
    y1: -280.59,
    x2: 401.93,
    y2: -280.59,
    gradientTransform: "translate(-308.5 344.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#55abed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5da6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#64a2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7896be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#978392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c36856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fa470b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4404"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "redditrSad") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.27,135.17c-12.13-3.16-20.2-10.41-25-21.3a26.24,26.24,0,0,1-2.18-11.22c1.58.9,2.92,1.64,4.23,2.41,13.31,7.73,27.52,12.13,43,11.56,11.19-.4,21.61-3.32,30.61-10.28.91-.7,1.35-.54,1.92.44a44.25,44.25,0,0,0,18.82,17.61,41.14,41.14,0,0,0,22.48,3.73,39.46,39.46,0,0,0,15.22-4.71c.3-.17.6-.3.9-.44a3.42,3.42,0,0,1,.64,0c-.33,2-.6,4.07-1,6A71.69,71.69,0,0,1,128,160.94a69.43,69.43,0,0,1-19.55,16.13,94.1,94.1,0,0,1-35,11.16,123.56,123.56,0,0,1-55-5.07,71.28,71.28,0,0,1-16.94-8c-.43-.3-.84-.63-1.51-1.14a78.36,78.36,0,0,0,44.56-10.35,28.41,28.41,0,0,0,4.67-3.73c-14.82-1.54-24.73-9.41-30.85-22.64C23.25,136.75,28.23,137.79,33.27,135.17Z",
    transform: "translate(0 -2.71)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.64,54.76a40.2,40.2,0,0,1,31.48-14.31c1.18,0,2.19,0,2.49,1.71.37,2,4.17,2.52,5.68.84a2.18,2.18,0,0,1,2.79-.57c15.09,5.34,24.46,16,27.72,31.49,3.73,17.74-1.55,32.89-15.89,44.15-14.62,11.49-34.38,10.92-48.86-.84A41.9,41.9,0,0,1,82.56,89.94c-.4-2.78-.44-5.64-.64-8.5-.07-1,.34-1.74,1.45-1.85,3.09-.3,4.7-2.28,5.91-4.93a99.33,99.33,0,0,1,4.91-9.51c1.78-2.93,1.14-5.55-.31-8.24C93.55,56.28,93.14,55.6,92.64,54.76Z",
    transform: "translate(0 -2.71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.3,63.43a10.49,10.49,0,0,0-10.58,10.38V74a10.6,10.6,0,1,0,10.69-10.52Z",
    transform: "translate(0 -2.71)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.53,87.49a9.28,9.28,0,0,0,9.37-9.2v-.14c0-5.07-4.1-9.44-8.94-9.51a9.42,9.42,0,0,0-9.81,9.48,9.27,9.27,0,0,0,9.17,9.37Z",
    transform: "translate(0 -2.71)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.85,101.28a23.6,23.6,0,0,0-13.2,4.5,6.18,6.18,0,0,0-1.92,2.79c-.2.47.27,1.41.71,1.85.27.27,1.14.13,1.68-.07.74-.27,1.38-.74,2.08-1.07,5.31-2.52,10.72-3.8,16.1-.37a47.2,47.2,0,0,1,5.21,4.4c.73.67,1.44,1.58,2.58.87s1.72-1.81,1-3a22,22,0,0,0-3.39-4.67C134.52,103.46,130.85,101.31,126.85,101.28Z",
    transform: "translate(0 -2.71)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.38,71a13.25,13.25,0,0,0,16.3,6.15,3.82,3.82,0,0,0,1.84-1.55c2.29-4.23,4.47-8.5,6.59-12.8a3.4,3.4,0,0,0,.24-2.22C91.46,54,84.41,49.45,77.75,50.8,71.57,52,66.43,58,66.43,64.17,66.43,64.21,66.56,68.44,68.38,71Z",
    transform: "translate(0 -2.71)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M173.89,12.79c-6.25.27-12.53.51-18.78.61a5.9,5.9,0,0,0-5.31,2.75c-5.62,8.1-11.43,16.07-17.14,24.06-1.61,2.29-2.69,2.62-4.44,1.41a.14.14,0,0,1,0-.16c.47-.71.91-1.41,1.38-2.09q9.78-13.56,19.59-27.08a3.29,3.29,0,0,1,2.92-1.48c6.12-.13,12.2-.4,18.31-.6,1.72-.07,3.94-.81,3.9,2.55",
    transform: "translate(0 -2.71)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.49,81.81a49.07,49.07,0,0,0-5.71-20.7A10.55,10.55,0,0,1,168,63.3a10.85,10.85,0,0,1-2.48,18.51Z",
    transform: "translate(0 -2.71)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 183.36,
    cy: 8.64,
    r: 8.64
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.5,54.5a21.8,21.8,0,0,0,4,3c5.15,3,11.31,2.14,14,2",
    transform: "translate(0 -2.71)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.5,61.5c2,1,5.93,3,10,2a20.27,20.27,0,0,0,3-1",
    transform: "translate(0 -2.71)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.5,87.5a6.68,6.68,0,0,0-4,4c-.45,1.47-.57,4.12,1,5,1.24.69,3.08,0,4-1C116,93.83,115.77,90.49,113.5,87.5Z",
    transform: "translate(0 -2.71)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedditrSad);
export default __webpack_public_path__ + "static/media/redditrSad.a9d172f57d8b001990189160cba7382c.svg";
export { ForwardRef as ReactComponent };